export default __webpack_public_path__ + "static/media/concerned.de61d5ba.svg";